'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _adverseEvent = require('./adverse-event.service');

var _adverseEvent2 = _interopRequireDefault(_adverseEvent);

var _adverseEvent3 = require('./adverse-event.component');

var _adverseEvent4 = _interopRequireDefault(_adverseEvent3);

var _information = require('./information/information.module');

var _information2 = _interopRequireDefault(_information);

var _animalHistory = require('./animal-history/animal-history.module');

var _animalHistory2 = _interopRequireDefault(_animalHistory);

var _animalInformation = require('./animal-information/animal-information.module');

var _animalInformation2 = _interopRequireDefault(_animalInformation);

var _caseReference = require('./case-reference/case-reference.module');

var _caseReference2 = _interopRequireDefault(_caseReference);

var _closure = require('./closure/closure.module');

var _closure2 = _interopRequireDefault(_closure);

var _ownerForm = require('./owner-form/owner-form.module');

var _ownerForm2 = _interopRequireDefault(_ownerForm);

var _vetForm = require('./vet-form/vet-form.module');

var _vetForm2 = _interopRequireDefault(_vetForm);

var _otherForm = require('./other-form/other-form.module');

var _otherForm2 = _interopRequireDefault(_otherForm);

var _contactList = require('./contact-list/contact-list.module');

var _contactList2 = _interopRequireDefault(_contactList);

var _riskAnalysis = require('./risk-analysis/risk-analysis.module');

var _riskAnalysis2 = _interopRequireDefault(_riskAnalysis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.adverseEvent', [_angularUiRouter2.default, _information2.default, _animalHistory2.default, _animalInformation2.default, _caseReference2.default, _closure2.default, _ownerForm2.default, _vetForm2.default, _otherForm2.default, _contactList2.default, _riskAnalysis2.default]).component('adverseEvent', _adverseEvent4.default).service('AdverseEventService', _adverseEvent2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('adverseEventEdit', {
    parent: 'app',
    url: '/adverse-events/{id:int}',
    component: 'adverseEvent',
    resolve: {
      adverseEvent: function adverseEvent(AdverseEventService, $stateParams) {
        return AdverseEventService.getAdverseEvent($stateParams.id).then(function (r) {
          return r.data;
        });
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      company: function company(CompanyService, adverseEvent) {
        return CompanyService.getCompany(adverseEvent.MemberId).then(function (r) {
          return r.data;
        });
      },
      contactTypes: function contactTypes(AdverseEventService) {
        return AdverseEventService.getContactTypes();
      },
      statuses: function statuses(AdverseEventService) {
        return AdverseEventService.getStatuses();
      },
      sexes: function sexes(AdverseEventService) {
        return AdverseEventService.getAnimalSexes();
      },
      symptoms: function symptoms(AdverseEventService) {
        return AdverseEventService.getSymptoms();
      },
      occurrenceLikelihoods: function occurrenceLikelihoods(AdverseEventService) {
        return AdverseEventService.getOccurrenceLikelihoods();
      },
      injuryProbabilities: function injuryProbabilities(AdverseEventService) {
        return AdverseEventService.getInjurityProbabilities();
      },
      injurySeverities: function injurySeverities(AdverseEventService) {
        return AdverseEventService.getInjuritySeverities();
      }
    }
  }).state('adverseEventCreate', {
    parent: 'app',
    url: '/adverse-events/create',
    component: 'adverseEvent',
    data: {
      permissions: {
        only: [_roles.USER, _roles.COMPANY_ADMIN],
        redirectTo: 'dashboard'
      }
    },
    resolve: {
      adverseEvent: function adverseEvent(currentUser) {
        return {
          AEId: 0,
          MemberId: currentUser.MemberId,
          Status: 'OPEN'
        };
      },
      statuses: function statuses(AdverseEventService) {
        return AdverseEventService.getStatuses();
      },
      company: function company(CompanyService, currentUser) {
        return CompanyService.getCompany(currentUser.MemberId).then(function (r) {
          return r.data;
        });
      },
      contactTypes: function contactTypes(AdverseEventService) {
        return AdverseEventService.getContactTypes();
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      sexes: function sexes(AdverseEventService) {
        return AdverseEventService.getAnimalSexes();
      },
      symptoms: function symptoms(AdverseEventService) {
        return AdverseEventService.getSymptoms();
      },
      occurrenceLikelihoods: function occurrenceLikelihoods(AdverseEventService) {
        return AdverseEventService.getOccurrenceLikelihoods();
      },
      injuryProbabilities: function injuryProbabilities(AdverseEventService) {
        return AdverseEventService.getInjurityProbabilities();
      },
      injurySeverities: function injurySeverities(AdverseEventService) {
        return AdverseEventService.getInjuritySeverities();
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/adverse-event/adverse-event.module.js